<template>
  <v-card class="elevation-0">
    <v-row align="center" justify="center" class="text-center" no-gutters>
      <v-col>
        <h3>NEM</h3>
      </v-col>
    </v-row>
    <v-row v-if="!intervention && !suspension && !administered" align="center" justify="center" no-gutters>
      <h4>NO INTERVENTION</h4>
    </v-row>
    <v-row v-if="suspension" align="center" justify="center" class="bg-orange" no-gutters>
      <h4>MARKET SUSPENSION</h4>
    </v-row>
    <v-row v-if="intervention" align="center" justify="center" class="bg-yellow" no-gutters>
      <h4>INTERVENTION</h4>
    </v-row>
    <v-row v-if="administered" align="center" justify="center" class="bg-light-green" no-gutters>
      <h4>ADMINISTERED PRICES</h4>
    </v-row>
    <v-row v-if="intervention! || suspension! || administered!" align="center" justify="center" class="text-center" no-gutters>
      <v-col>
        <v-radio-group v-model="priceMode">
          <v-row align="center" justify="center" class="text-center" no-gutters>
            <v-col class="mt-2 text-caption">Prices Shown?</v-col>
          </v-row>
          <v-row align="center" justify="center" class="text-center text-caption" no-gutters>
            <v-col cols="auto">
              <v-radio name="priceShown" label="Financial" value="financial" class="text-caption" />
            </v-col>
            <v-col cols="auto">
              <v-radio name="priceShown" label="Physical" value="physical" class="text-caption" />
            </v-col>
          </v-row>
        </v-radio-group>
      </v-col>
    </v-row>
  </v-card>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { mapState, mapWritableState } from 'pinia';
import { useStore } from '@/stores/main';

export default defineComponent({
  name: 'NemComponent',
  computed: {
    ...mapState(useStore, ['intervention', 'suspension', 'administered']),
    ...mapWritableState(useStore, ['priceMode'])
  }
});
</script>
